const data = () => ({
    formSubmitted: false,
    emailTaken: false,
    emailNotValid: false,
    phoneNotValid: false,
    usernameTaken: false,
    registrationSuccess: false,
    serverError: false,
    emailOrPhone: '',
    countryCodeId: undefined, // this must be here otherwise validator validates only once
    username: '',
    password: '',
    passwordConfirm: '',
    memberType: -1,
    validAge: '',
    loading: false,
    emailOrPhoneTaken: false,
    suggestedUsernames: [],
    acceptTerms: '',
    userHash: null,
    userEmail: null,
    makeSuperAdmin: null,
});

function onSubmit() {
    this.loading = false;
    this.emailOrPhoneTaken = false;
    this.emailNotValid = false;
    this.phoneNotValid = false;
    this.usernameTaken = false;
    this.registrationSuccess = false;
    this.serverError = false;
    this.formSubmitted = true;

    if (!this.$v.$invalid) {
        this.submitForm();
    }
}

function onFailure(data) {
    const errors = _.get(data, 'errors');

    this.loading = false;

    if (!errors) {
        this.serverError = true;
        return toastr.error(_.get(this, 'translate.home.errorCommon'));
    }
    if (_.get(errors, 'email[0]', '') === "The email has already been taken.") {
        this.emailOrPhoneTaken = true;
    }
    if (_.get(errors, 'phoneNumber[0]', '') === "The phone number has already been taken.") {
        this.emailOrPhoneTaken = true;
    }
    if (_.get(errors, 'email[0]', '') === "The email must be a valid email address.") {
        this.emailNotValid = true;
    }
    if (_.get(errors, 'phoneNumber[0]', '') === "The phone number must be a number.") {
        this.phoneNotValid = true;
    }
    if (_.get(errors, 'username[0]', '') === "The username has already been taken.") {
        this.usernameTaken = true;
        this.suggestedUsernames = _.get(data, 'suggestedUsernames', []);
    }

    this.captchaNotValid = _.get(errors, 'captcha[0]', '') === "The captcha is invalid";
}

function applySuggestedUsername(username) {
    this.username = username;
}

export default {
    data,
    watch: {
        username() {
            this.usernameTaken = false;
            this.suggestedUsernames = [];
        }
    },
    methods: {
        onSubmit,
        onFailure,
        applySuggestedUsername,
    },
}
